/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, March 4th 2022, 7:59:17 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Routes, Route } from "react-router-dom";
import {
  ServicesListPage,
  ServiceBuilderBaseLayout,
  BPMNWorkflowConfigurationPage,
  LayoutsPage,
  SubmissionFormsPage,
  TeamAccessConfigurationPage,
  ServiceRegistrationFormsPage,
  ServiceFormBuilderPage,
  BillingConfigurationsListPage,
  BillingConfigurationPage,
  DocumentTemplatesListPage,
  DocumentTemplatePage,
  AdvancedSettingsPage,
} from "service-builder/pages";
import { ServiceBuilderProvider } from "service-builder/providers";
import { SERVICE_BUILDER_RELATIVE_URLS } from "./ServiceBuilderURLS";

export const ServiceBuilderRoutes = () => {
  return (
    <Routes>
      {/* <Route path="services/*">
        <Route path="" element={<ServicesListPage />} /> */}
      <Route path={SERVICE_BUILDER_RELATIVE_URLS.services} element={<ServicesListPage />} />
      <Route
        // path="edit/:serviceId*"
        path="*"
        element={
          <ServiceBuilderProvider>
            <ServiceBuilderBaseLayout />
          </ServiceBuilderProvider>
        }
      >
        <Route path={SERVICE_BUILDER_RELATIVE_URLS.serviceBuilderRoot} element={<BPMNWorkflowConfigurationPage />} />

        <Route path={SERVICE_BUILDER_RELATIVE_URLS.submissionForms} element={<SubmissionFormsPage />} />

        <Route
          path={SERVICE_BUILDER_RELATIVE_URLS.serviceRegistrationForms}
          element={<ServiceRegistrationFormsPage />}
        />

        <Route path={SERVICE_BUILDER_RELATIVE_URLS.teamAccess} element={<TeamAccessConfigurationPage />} />

        <Route path={SERVICE_BUILDER_RELATIVE_URLS.layouts} element={<LayoutsPage />} />

        <Route path={SERVICE_BUILDER_RELATIVE_URLS.serviceFormBuilder} element={<ServiceFormBuilderPage />} />

        <Route
          path={SERVICE_BUILDER_RELATIVE_URLS.billingConfigurationsList}
          element={<BillingConfigurationsListPage />}
        />

        <Route path={SERVICE_BUILDER_RELATIVE_URLS.billingConfiguration} element={<BillingConfigurationPage />} />

        <Route path={SERVICE_BUILDER_RELATIVE_URLS.documentTemplatesList} element={<DocumentTemplatesListPage />} />

        <Route path={SERVICE_BUILDER_RELATIVE_URLS.documentTemplate} element={<DocumentTemplatePage />} />

        <Route path={SERVICE_BUILDER_RELATIVE_URLS.advancedSettings} element={<AdvancedSettingsPage />} />
      </Route>
      {/* </Route> */}
    </Routes>
  );
};
